// Taken from https://knowledge.hubspot.com/forms/what-domains-are-blocked-when-using-the-forms-email-domains-to-block-feature?KBOpenTab
export const BLOCKED_EMAIL_DOMAINS = ['.edu'];
